import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/partner/TopBanner.css";

function firstNameFromProfile(profile) {
  const user = profile?.user || {};
  return user.first_name || (user.display_name || user.username || "there").split(" ")[0];
}

export default function TopBanner({ profile, isSuperuser = false, statusMessage = "" }) {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const referralCode = profile?.user?.user_id || localStorage.getItem("user_id") || "";
  const referralUrl = useMemo(() => {
    if (!referralCode) return "";
    return `${window.location.origin}/new-project/${referralCode}`;
  }, [referralCode]);

  async function copyReferralLink() {
    if (!referralUrl) return;
    await navigator.clipboard.writeText(referralUrl);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  }

  if (isSuperuser) {
    return (
      <section className="portal-hero">
        <div>
          <span className="portal-hero-eyebrow">SCD Operations</span>
          <h1>Partner Portal Overview</h1>
          <p>Manage partners, leads, clients, commissions, and team access.</p>
          {statusMessage && <small>{statusMessage}</small>}
        </div>
        <div className="portal-hero-actions">
          <button type="button" className="btn btn-primary" onClick={() => navigate("/employees?group=sales")}>Review Partners</button>
          <button type="button" className="btn btn-secondary" onClick={() => navigate("/leads")}>View Leads</button>
        </div>
      </section>
    );
  }

  const commission = profile?.partner?.commission_percentage;

  return (
    <section className="portal-hero">
      <div>
        <span className="portal-hero-eyebrow">Partner Dashboard</span>
        <h1>Welcome back, {firstNameFromProfile(profile)}</h1>
        <p>
          {commission
            ? `You earn ${Number(commission).toLocaleString(undefined, { maximumFractionDigits: 2 })}% commission on approved client projects.`
            : "Share your client form to start referring qualified projects."}
        </p>
        {statusMessage && <small>{statusMessage}</small>}
      </div>
      <div className="portal-hero-actions">
        <button type="button" className="btn btn-primary" onClick={copyReferralLink} disabled={!referralUrl}>
          {copied ? "Copied" : "Copy Client Form Link"}
        </button>
        <button type="button" className="btn btn-secondary" onClick={() => navigate("/leads")}>View Leads</button>
      </div>
    </section>
  );
}
